/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Service_ContactInputs */

const de_commons_footer_service_contact = /** @type {(inputs: Commons_Footer_Service_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

/** @type {(inputs: Commons_Footer_Service_ContactInputs) => LocalizedString} */
const en_commons_footer_service_contact = de_commons_footer_service_contact;

/**

* @param {Commons_Footer_Service_ContactInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_service_contact = /** @type {((inputs?: Commons_Footer_Service_ContactInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Service_ContactInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_service_contact(inputs)
	return en_commons_footer_service_contact(inputs)
});